import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  processIcon: {
    color: 'white',
    display: 'inline-block',
    padding: '5px',
    width: '20px',
    height: '20px',
    backgroundColor: '#7B62D5',
    borderRadius: '50%',
    position: 'relative',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    '& span': {
      verticalAlign: 'middle',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '15px',
      lineHeight: '20px',
    },
  },
}));
